
import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { GfTitleService } from '../../../core/services/core.title.service';
import { UiService } from '../../../core/services/core.ui.service';
import { ScmService } from '../services/scm.service';
import * as _ from 'lodash';

@Component({
  selector: 'scm-merge',
  template: require('./scm.merge.component.html'),
})
export class ScmMergeComponent implements OnInit {
  @Input() project: any;
  @Input() scm: any;
  @Input() projectMenu: any;

  mergeLoading = false;
  mergeWorking = false;
  merge: any = false;

  view: string;
  from: any;
  to: any;

  constructor(
    private stateService: StateService,
    private titleService: GfTitleService,
    private uiService: UiService,
    private scmService: ScmService
  ) {}

  ngOnInit() {
    this.view = _.get(this.stateService.params, 'view', 'inline');
    this.titleService.setTitle(
      this.project.name, _.startCase(this.scm.scmType) + ' Merge'
    );

    const fromName = decodeURIComponent(
        _.get(this.stateService.params, 'from', '')
    );
    this.from = {
      name: fromName,
      searching: false,
      searchItemsResult: [],
      autoSubmitTimer: null,
    };

    const toName = decodeURIComponent(
        _.get(this.stateService.params, 'to', '')
    );
    this.to = {
      name: toName,
      searching: false,
      searchItemsResult: [],
      autoSubmitTimer: null,
    };

    this.refreshMerge();
  }

  searchBranch(searchObj: any) {
    if (searchObj.name.length < 3) {
      return;
    }
    searchObj.searching = true;
    const unixName = _.get(this.stateService.params, 'unixName', '');
    this.scmService
      .searchBranch(unixName, searchObj.name)
      .then((response: any) => {
        searchObj.searchItemsResult = response.items;
        searchObj.searching = false;
      })
      .catch(() => {});
  }

  addBranchAutoSubmit(searchObj: any) {
    if (searchObj.autoSubmitTimer) {
      clearTimeout(searchObj.autoSubmitTimer);
    }
    searchObj.autoSubmitTimer = setTimeout(() => {
      this.searchBranch(searchObj);
    }, 750);
  }

  addBranchFrom(branch: string) {
    this.from.name = branch;
    this.from.searching = false;
    this.from.searchItemsResult = [];
  }

  addBranchTo(branch: string) {
    this.to.name = branch;
    this.to.searching = false;
    this.to.searchItemsResult = [];
  }

  refreshMerge() {
    if (this.from.name !== '' && this.to.name !== '') {
      this.mergeLoading = true;
      this.merge = false;
      const unixName = _.get(this.stateService.params, 'unixName', '');
      this.scmService
        .merge(unixName, {
          from: this.from.name,
          to: this.to.name,
          rel: 'diffs,commits,comments',
        })
        .then((data: any) => {
          this.merge = data;
          this.mergeLoading = false;
        })
        .catch((response: any) => {
          if (response.status === 403) {
            this.uiService.message.showWarning(
              "Sorry, you don't have access to at least one of the specified paths"
            );
          } else {
            this.uiService.message.showWarning(
              "Sorry, the From, To or both parameters are not valid in this project's SCM repository. For SVN, don't include the branches/ or tags/ prefix in the name",
              'Invalid Merge'
            );
          }
          this.mergeLoading = false;
        });
    }
  }

  updateMerge() {
    const queryParams = this.stateService.params;
    if (
      queryParams.from === this.from.name &&
      queryParams.to === this.to.name
    ) {
      this.refreshMerge();
    } else {
      this.stateService.go('.', {
        ...queryParams,
        from: this.from.name,
        to: this.to.name,
      });
    }
  }

  completeMerge() {
    if (this.from.name !== '' && this.to.name !== '') {
      this.mergeWorking = true;
      const unixName = _.get(this.stateService.params, 'unixName', '');
      this.scmService
        .saveMerge(unixName, {
          from: this.from.name,
          to: this.to.name,
          rel: 'diffs,commits,comments',
        })
        .then((data: any) => {
          this.merge = data;
          this.mergeWorking = false;
          this.uiService.message.showSuccess(
            'Successfully merged ' +
              this.from.name +
              ' into ' +
              this.to.name,
            'Merge Completed'
          );
        })
        .catch((response: any) => {
          this.mergeWorking = false;
          _.forEach(response, (msg) => {
            this.uiService.message.showWarning(msg, 'Merge Failed');
          });
        });
    }
  }

  setView(view: string) {
    if (this.view !== view) {
      this.view = view;
      const queryParams = this.stateService.params;

      this.stateService.go('.', {
        ...queryParams,
        view: view
      });
    }
  }
}
